import React from "react";
import { FormProvider } from "react-hook-form";
import { InputAdornment, Stack, Typography } from "@mui/material";

import { RFHTextField as RHFTextField } from "../../../components/RFH";
import { useResponsive } from "../../../hooks/useResponsive";
import { CustomButton } from "../../../components/Button/Button";
import { useCompanyInfoForm } from "./hooks/useCompanyInfoForm";

function CompanyInfoForm({ initialData }) {
  const isMobile = useResponsive("down", "md");
  const { methods, isPending, domainUrl, hasChanges, onSubmit, validateDomain } =
    useCompanyInfoForm(initialData);

  return (
    <FormProvider {...methods}>
      <div className={`${isMobile ? "mt-2" : "mt-32"} form-section`}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <React.Fragment>
            <Typography className="setting-heading mb-4 ml-0">
              Company Info
            </Typography>
            <Stack direction={isMobile ? "column" : "row"} spacing={2.5}>
              <RHFTextField
                name="company_name"
                label="Name"
                defaultPadding={false}
                className="company-info-form-text-field"
              />
              <RHFTextField
                label="URL"
                name="domain"
                onBlur={(e) => validateDomain(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="domain-static">
                      .{domainUrl.split(".").splice(1).join(".")}
                    </InputAdornment>
                  ),
                }}
                defaultPadding={false}
                className="company-info-form-text-field"
                disabled
              />
              <RHFTextField
                name="email"
                label="E-mail address"
                defaultPadding={false}
                className="company-info-form-text-field"
              />
            </Stack>
          </React.Fragment>

          <Stack alignItems="end" className="mt-32">
            <CustomButton
              variant="contained"
              type="submit"
              className="theme-bg-color company-info-form-update-button"
              disabled={isPending || !hasChanges()}
            >
              Update
            </CustomButton>
          </Stack>
        </form>
      </div>
    </FormProvider>
  );
}

export default React.memo(CompanyInfoForm);
